import { initNav } from "./nav.js";
import { initPartials, initHead } from "./partials.js";
import { initCarousel } from "./carousel.js";

// Initialize head partial first (loads common head content and sets title)
initHead().then(() => {
  // Load other partials, then initialize navigation and carousel
  return initPartials();
}).then(() => {
  initNav();
  // Initialize carousel after a short delay to ensure jQuery/Slick are loaded
  // (they're loaded via CDN in the HTML head)
  if (document.querySelector(".home--carousel-slides")) {
    // Wait for jQuery and Slick to be available
    const checkDependencies = () => {
      if (typeof window.$ !== 'undefined' && typeof window.$.fn.slick !== 'undefined') {
        initCarousel();
      } else {
        setTimeout(checkDependencies, 50);
      }
    };
    checkDependencies();
  }
});
